/*
 * @Author: rht
 * @Date: 2022-03-04 18:12:51
 * @LastEditTime: 2022-03-07 10:57:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \portal\src\store\modules\cloudMonitor\variable.js
 */
const variable = {
    state: {
      terminalId: "", // 设备分组id
    },
    mutations: {
      // 设置终端id
      SETTERMINALID(state, id) {
        state.terminalId = id
      },
    },
    actions: {
      setTerminalId({ commit }, id) {
        commit('SETTERMINALID', id)
      }
    }
  }
  export default variable